import type { Geography } from "./types";
/** Schematic DEMO positions, deliberately not asserted geographic coordinates.
 * Add reviewed maps with provenance here; journey rows live in the Org source.
 * Coordinates use each map's SVG viewBox, allowing geographic projections later.
 */
export const geographies: Record<string, Geography> = {
  "demo-greece": {
    label: "Teaching route schematic", viewBox: "0 0 960 430",
    notice: "DEMO schematic — positions and route must be verified before teaching",
    cities: { Philippi: [720, 65], Thessalonica: [490, 100], Berea: [335, 145],
      Athens: [550, 330], Corinth: [300, 340] },
    regions: [{ label: "Route schematic · not to scale", x: 80, y: 45 }]
  }
};
